import { post } from "@toruslabs/http-helpers";

import config from "@/config";
import { ValidatePhoneNumberApiResponse } from "@/utils/interfaces";
import log from "@/utils/logger";

export function jsonToHash(url: string, jsonData: Record<string, string>): string {
  const params = new URLSearchParams();

  Object.keys(jsonData).forEach((key) => {
    if (jsonData[key]) params.append(key, jsonData[key] as string);
  });
  const finalUrl = `${url}#${params}`;
  return finalUrl;
}

export function queryToJson(url: string): Record<string, string> {
  const finalUrl = new URL(url);
  const { searchParams } = finalUrl;
  const jsonParams: Record<string, string> = {};
  searchParams.forEach((val, key) => {
    jsonParams[key] = decodeURIComponent(val);
  });
  return jsonParams;
}

export function sessionStorageAvailable(): boolean {
  let storage;
  try {
    storage = window.sessionStorage;
    const x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return (
      error &&
      // everything except Firefox
      (error.code === 22 ||
        // Firefox
        error.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        error.name === "QuotaExceededError" ||
        // Firefox
        error.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length > 0
    );
  }
}

export const validatePhoneNumber = async (phoneNumber: string): Promise<{ success: boolean; number: string; flag: string }> => {
  try {
    const result = await post<ValidatePhoneNumberApiResponse>(`${config.authServerUrl}/api/v3/phone_number/validate`, {
      phone_number: phoneNumber,
    });
    if (result && result.success) return { success: true, number: result.parsed_number, flag: result.country_flag };
    return { success: false, number: "", flag: "" };
  } catch (error: unknown) {
    log.error("error validating phone number", error);
    if ((error as Response).status === 400) {
      return { success: false, number: "", flag: "" };
    }
    // sending true because we don't want the user to be stuck on a flow
    // if there is an error with the api or something went wrong.
    return { success: true, number: phoneNumber, flag: "" };
  }
};

export const getSiteName = (window: Window): string => {
  const { document } = window;

  const siteName = document.querySelector<HTMLMetaElement>('head > meta[property="og:site_name"]');
  if (siteName) {
    return siteName.content;
  }

  const metaTitle = document.querySelector<HTMLMetaElement>('head > meta[name="title"]');
  if (metaTitle) {
    return metaTitle.content;
  }

  if (document.title && document.title.length > 0) {
    return document.title;
  }

  return window.location.hostname;
};
